import React, { Fragment } from 'react'
import { Grid, Card, Confirm } from 'semantic-ui-react'
import { STATS_UPDATE as STATS_UPDATE_ROUTE } from './routes'
import { MainContext } from './State'
import PropTypes from 'prop-types'

const ClosePlay = ({ history }) => {
  return (
    <MainContext.Consumer>
      {({
        onClose,
        gameData: { id },
        showEndGameConfirm,
        onEndGameConfirm,
        onEndGameCancel,
        endGameConfirmVisible
      }) => (
        <Fragment>
          <Grid.Row
            style={{
              padding: 0
            }}
          >
            <Card
              fluid
              style={{
                color: 'white',
                backgroundColor: 'orangered',
                height: 350,
                lineHeight: 8,
                fontWeight: 'bolder',
                fontSize: 30,
                margin: 0
              }}
              onClick={onClose}
            >
              <Card.Content>
                <b>Close Play</b>
              </Card.Content>
            </Card>
          </Grid.Row>
          <Grid.Row
            columns="equal"
            style={{
              padding: 0
            }}
          >
            <Grid.Column
              style={{
                padding: 0
              }}
            >
              <Card
                fluid
                style={{
                  borderRadius: 0,
                  margin: 0,
                  color: 'black',
                  backgroundColor: 'yellow'
                }}
                onClick={() => history.replace(STATS_UPDATE_ROUTE.format(id))}
              >
                <Card.Content textAlign="center">
                  <b>Game Stats</b>
                </Card.Content>
              </Card>
            </Grid.Column>
            <Grid.Column
              style={{
                padding: 0
              }}
            >
              <Card
                fluid
                style={{
                  borderRadius: 0,
                  margin: 0,
                  color: 'white',
                  backgroundColor: 'red'
                }}
                onClick={showEndGameConfirm}
              >
                <Confirm
                  open={endGameConfirmVisible}
                  onConfirm={onEndGameConfirm}
                  onCancel={onEndGameCancel}
                />
                <Card.Content textAlign="center">
                  <b>End Game</b>
                </Card.Content>
              </Card>
            </Grid.Column>
          </Grid.Row>
        </Fragment>
      )}
    </MainContext.Consumer>
  )
}

ClosePlay.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
}

export default ClosePlay



// WEBPACK FOOTER //
// ./src/components/Controller/ClosePlay.jsx